import React, { useEffect } from 'react';
import styles from "../myprofile/myprofile.module.css";
import ProfileMenu from '../../Components/profilemenu/ProfileMenu';
import DashCards from '../../Components/DashCards';
import PODetailsComp from '../../Components/schedulePOComps/PODetailsComp';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getScheduleOrderDetailsThunk } from '../../../../Website/redux/scheduleOrderSlice';

const PODetails = () => {
    const { id } = useParams();
    const { refresh } = useSelector(state => state.scheduleOrder);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getScheduleOrderDetailsThunk(id));
    }, [id, refresh, dispatch]);

    return (
        <div className={styles.myprofile}>
            <div className={styles.promenu}>
                <ProfileMenu />
            </div>
            <div style={{ display: 'flex', gap: '24px', flexDirection: "column", flex: 1, minWidth: 0 }}>
                <DashCards type="schedule" />
                <div style={{ display: 'flex', gap: '24px', width: '100%' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <PODetailsComp id={id} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PODetails;